module.exports = __webpack_public_path__ + "media/newstyle/images/medium-shot-excited-woman-with-laptop-mini-2-f3481a294b318d25300ff103092bfb3f.png";